import { EquatorialCoord } from '@hscmap/angle';
import {
  BookmarkModule,
  IBookmark,
  BookmarkEntry,
  IBookmarkFolder,
  foldersIn,
  newBookmarkFolder,
} from '@/modules/BookMarkModule';
import { assert } from '@/utils/error';
import { Component, Vue, Prop } from "vue-property-decorator";
import FolderSelector from "./FolderSelector.vue";
import { store } from '@/store';

@Component({
  components: { FolderSelector },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: BookmarkModule

  folder = this.module.root

  newFolder() {
    const path = this.folderPaths.filter((p) => p.folder === this.folder)[0].path
    const name = prompt(`Folder name ?\n> ${path}`)
    if (name) {
      const newFolder = newBookmarkFolder(name)
      this.folder.children.push(newFolder)
    }
  }

  goto(e: IBookmark) {
    const globe = store.currentGlobe()
    const { a, d, fovy, roll } = e.view
    const coord = EquatorialCoord.fromRad(a, d)
    globe.viewFactory.jumpTo({ fovy, roll }, { coord })
  }

  remove(e: BookmarkEntry) {
    const i = this.folder.children.indexOf(e)
    assert(i >= 0)
    if (confirm(this.$t('delete?', { name: e.name }) as string)) {
      this.folder.children.splice(i, 1)
    }
  }

  // coord60(e: Bookmark) {
  //     const { a, d } = e.view
  //     const { a: a60, d: d60 } = EquatorialCoord.fromRad(a, d).toString()
  //     return `&alpha;=${a60} &delta;=${d60}`
  // },

  move(srcFolder: IBookmarkFolder, entry: BookmarkEntry, newFolder: IBookmarkFolder) {
    const i = srcFolder.children.indexOf(entry)
    assert(i >= 0)
    srcFolder.children.splice(i, 1)
    newFolder.children.push(entry)
  }

  get folderPaths() {
    return foldersIn(this.module.root)
  }
}
